"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentCustomClaimReducerBase = void 0;
var tslib_1 = require("tslib");
var actions_1 = require("../../constants/actions");
var currentCustomClaimReducerBase = function (state, action) {
    if (!action) {
        return state || null;
    }
    if (action.type === actions_1.GET_CUSTOM_CLAIM_SUCCESS) {
        return tslib_1.__assign(tslib_1.__assign({}, state), action.successValues.item);
    }
    if (action.type === actions_1.PATCH_CUSTOM_CLAIM_SUCCESS) {
        return tslib_1.__assign(tslib_1.__assign({}, state), action.successValues.item);
    }
    if (action.type === 'SIGN_OUT_SUCCESS') {
        return null;
    }
    return state || null;
};
exports.currentCustomClaimReducerBase = currentCustomClaimReducerBase;
